/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DsaiIngestionStageState {
    PENDING = 'pending',
    RUNNING = 'running',
    DONE = 'done',
}
